import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { useMediaQuery } from "@react-hook/media-query"
import BackgroundImage from "gatsby-background-image"

const StyledBackgroundSection = styled(BackgroundImage)`
  width: 100%;
  min-height: 500px;
  ${({ styles }) => styles};
  .layer {
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, rgba(0,0,0,.8) 30%, rgba(0,0,0,0));
    position:absolute;
  }
`
const BackgroundSection = ({ image, children, styles, className, opacity }) => {
  const mobile = useMediaQuery("only screen and (max-width: 769px)")
  if (mobile) {
    return <>
      {children}
    </>
  }
  return (
    <StyledBackgroundSection
      Tag="section"
      className={className}
      fluid={image}
      styles={styles}
      backgroundColor="#1b1b1b"
    >
      <div className="layer"/>
      {children}
    </StyledBackgroundSection>
  )
}

BackgroundSection.propTypes = {
  opacity: PropTypes.string
}
BackgroundSection.defaultProps = {
  opacity: '.3',
}
export default BackgroundSection